import Drawer, { Props as DrawerProps } from '../../../../../components/Drawer';
import TileDrawerStepper from '../../../../shared/TileDrawerStepper';
import BarGraphSteps, { Steps } from '../BarGraphSteps';
import DrawerHeader from '../DrawerHeader';

export interface BarGraphDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {}

export const BarGraphDrawer = ({ open, onClose }: BarGraphDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <TileDrawerStepper header={<DrawerHeader />} steps={Steps}>
        {({ currentStep, goToNextStep }) => <BarGraphSteps currentStep={currentStep} goToNextStep={goToNextStep} />}
      </TileDrawerStepper>
    </Drawer>
  );
};

export default BarGraphDrawer;
